module.exports = __webpack_public_path__ + "static/media/workingmemory-words-7.a53fa76d.mp3";